import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const laurelConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Laurel Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Laurel, FL. Sam\'s Tree Service handles dangerous and hazardous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_laurel',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Laurel',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  
  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Laurel Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the properties and neighborhoods 
     of <strong>Laurel</strong> with expert tree care built for Florida's environment. 
     Whether you're dealing with a towering oak dropping limbs near your home, a cluster 
     of palms leaning toward your fence after a storm, or dense canopy growth blocking 
     your view and creating storm risk, our team has the experience to handle it safely 
     and efficiently.`,

    `We specialize in <strong>dangerous tree removal and professional trimming</strong> 
     tackling overgrown canopies, storm compromised trunks, diseased limbs, and trees 
     encroaching on structures or utility lines. We tailor every job to your property 
     and get it done with minimal disruption to your daily life.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care across 
     <strong>Laurel</strong> and throughout the <strong>Venice and South Sarasota</strong> 
     area protecting your home and keeping your landscape looking its best all year long.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Laurel, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Laurel = () => <LocationPage config={laurelConfig} />;
export default Services_Laurel;
